import { useEffect } from "react";

export const useEditorAnimationLayoutSync = ({ playPause, layerCompData }) => {
  useEffect(() => {
    if (playPause.animationCompleted) {
      for (let index = 0; index < layerCompData.length; index++) {
        let component = layerCompData[index];
        let currentPosition = {
          x: 0,
          y: 0,
          width: 0,
          height: 0,
        };
        const targetElement = document.getElementById(component.id);
        const canvasElement = document.getElementById("canvas-page");

        if (targetElement && canvasElement) {
          const targetRect = targetElement.getBoundingClientRect();
          const canvasRect = canvasElement.getBoundingClientRect();

          currentPosition = {
            x: targetRect.left - canvasRect.left,
            y: targetRect.top - canvasRect.top,
            width: targetRect.width,
            height: targetRect.height,
          };
        }
        layerCompData[index].componentStyles.left =
          currentPosition.x -
          (layerCompData[index].componentStyles.translateX || 0);
        layerCompData[index].componentStyles.top =
          currentPosition.y -
          (layerCompData[index].componentStyles.translateY || 0);
        // Images keep authored width/height so hit areas stay aligned
        // (useHitAreaScaleOnImageSizeChange handles intentional size changes).
        if (component?.componentType !== "Image") {
          layerCompData[index].componentStyles.height = currentPosition.height;
          layerCompData[index].componentStyles.width = currentPosition.width;
        }
      }
    }
  }, [playPause.animationCompleted]);
};
